//module types
export const SET_MODULE = 'SET_MODULE'
export const REMOVE_MODULE = 'REMOVE_MODULE'
export const START_QUESTION = 'START_QUESTION'

export const SET_TIME = 'SET_TIME'
export const ADD_QUESTION_MODULE = 'ADD_QUESTION_MODULE'
export const TIME_OUT = 'TIME_OUT'
export const SET_TYPE_QUESTION = 'SET_TYPE_QUESTION'
export const SET_CURRENT_QUESTION = 'SET_CURRENT_QUESTION'
export const ADD_CURRENT_QUESTION = 'ADD_CURRENT_QUESTION'
export const ADD_QUESTIONS_LIST = 'ADD_QUESTIONS_LIST'
export const GET_CORRECT = 'GET_CORRECT'

export const NEXT_QUESTION = 'NEXT_QUESTION'
export const RESET_SUBTEST = 'RESET_SUBTEST'
export const SET_GLOBAL_COUNT = 'SET_GLOBAL_COUNT'
